var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { InternalProvider } from '../../util/InternalProvider';
import { defaultColor, IconData } from './iconData';
import { getSize } from './utils';
var SvgSpan = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  position: relative;\n  vertical-align: middle;\n  width: ", ";\n  height: ", ";\n  & > svg {\n    display: block;\n    width: 100%;\n    height: 100%;\n  }\n"], ["\n  display: inline-block;\n  position: relative;\n  vertical-align: middle;\n  width: ", ";\n  height: ", ";\n  & > svg {\n    display: block;\n    width: 100%;\n    height: 100%;\n  }\n"])), function (props) { return getSize(props.size); }, function (props) { return getSize(props.size); });
var LibraryIcon = function (_a) {
    var src = _a.src, fill = _a.fill, ariaLabel = _a.ariaLabel, title = _a.title, svgProps = _a.svgProps;
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", "aria-label": ariaLabel || title }, svgProps), IconData[IconData[src] ? src : 'IconPlaceholder']({
        fill: fill
    })));
};
export var Icon = React.forwardRef(function (_a, fRef) {
    var className = _a.className, title = _a.title, ariaLabel = _a.ariaLabel, src = _a.src, _b = _a.size, size = _b === void 0 ? 'normal' : _b, _c = _a.fill, fill = _c === void 0 ? defaultColor : _c, svgProps = _a.svgProps, other = __rest(_a, ["className", "title", "ariaLabel", "src", "size", "fill", "svgProps"]);
    return (React.createElement(InternalProvider, null,
        React.createElement(SvgSpan, __assign({ size: size, className: className, ref: fRef }, other), typeof src === 'string' ? (React.createElement(LibraryIcon, { src: src, title: title, fill: fill, ariaLabel: ariaLabel, svgProps: svgProps })) : (src))));
});
var templateObject_1;
